/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Moduł
 * @example "SALE_FLAT"
 */
export enum Module {
  SALE_FLAT = "SALE_FLAT",
  SALE_HOUSE = "SALE_HOUSE",
  SALE_PLOT = "SALE_PLOT",
  SALE_OTHER = "SALE_OTHER",
}

export interface OpinionUpdateInformation {
  /**
   * Id opinii
   * @format int64
   * @example 1
   */
  opinionId: number;
  /**
   * Średnia ocena społeczności
   * @format double
   * @example 3
   */
  communityScore: number;
  /**
   * Liczba komentarzy społeczności
   * @format int32
   * @example 2
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii społeczności
   * @format int32
   * @example 1
   */
  numberOfCommunityOpinions: number;
}

/**
 * Id lokalizacji
 * @example [{"id":15},{"id":25}]
 */
export interface LocationDto {
  /** @format int32 */
  id?: number;
  fullName?: string;
}

/** Oferta od */
export enum OfferFromEnum {
  OsobaPrywatna = "Osoba prywatna",
  Agencja = "Agencja",
}

/**
 * Id lokalizacji OSM
 * Lokalizacja OSM
 * @example [{"id":15},{"id":25}]
 */
export interface OsmLocationDto {
  /**
   * Id lokalizacji
   * @format int32
   */
  id?: number;
  /** Pełna lokalizacja */
  fullName?: string;
}

/** Typ budynku */
export enum PlotBuildingTypeEnum {
  Budowlana = "Budowlana",
  Rolna = "Rolna",
  Lesna = "Leśna",
  Pozostale = "Pozostałe",
}

export interface PlotsFilterDto {
  /**
   * Nazwa filtra
   * @example "Nazwa testowa"
   */
  name?: string;
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  module: Module;
  /**
   * Powiadomienia SMS
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia Email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia Push
   * @example true
   */
  pushAlert: boolean;
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Opóźnienie powiadomień
   * @format int32
   */
  notificationsDelay: number;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom?: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount?: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  includeAi: boolean;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  offerFrom?: OfferFromEnum[];
  /**
   * Id lokalizacji
   * @example [{"id":15},{"id":25}]
   */
  locations: LocationDto[];
  /**
   * Id lokalizacji OSM
   * @example [{"id":15},{"id":25}]
   */
  filterLocations?: OsmLocationDto[];
  /**
   * Id filtra
   * @format int64
   */
  id: number;
  buildingType?: PlotBuildingTypeEnum[];
}

export enum SortType {
  DATE_DESC = "DATE_DESC",
  DATE_ASC = "DATE_ASC",
  PRICE_DESC = "PRICE_DESC",
  PRICE_ASC = "PRICE_ASC",
  PRICE_PER_SQUARE_METER_ASC = "PRICE_PER_SQUARE_METER_ASC",
  PRICE_PER_SQUARE_METER_DESC = "PRICE_PER_SQUARE_METER_DESC",
  MODIFICATION_DATE = "MODIFICATION_DATE",
  SCORE_ASC = "SCORE_ASC",
  SCORE_DESC = "SCORE_DESC",
}

/** Typ budynku */
export enum OtherBuildingTypeEnum {
  Garaze = "Garaże",
  Hale = "Hale",
  Pozostale = "Pozostałe",
}

export interface OtherFilterDto {
  /**
   * Nazwa filtra
   * @example "Nazwa testowa"
   */
  name?: string;
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  module: Module;
  /**
   * Powiadomienia SMS
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia Email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia Push
   * @example true
   */
  pushAlert: boolean;
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Opóźnienie powiadomień
   * @format int32
   */
  notificationsDelay: number;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom?: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount?: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  includeAi: boolean;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  offerFrom?: OfferFromEnum[];
  /**
   * Id lokalizacji
   * @example [{"id":15},{"id":25}]
   */
  locations: LocationDto[];
  /**
   * Id lokalizacji OSM
   * @example [{"id":15},{"id":25}]
   */
  filterLocations?: OsmLocationDto[];
  /**
   * Id filtra
   * @format int64
   */
  id: number;
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /**
   * Piętro od
   * @format int32
   * @example 4
   */
  floorFrom?: number;
  /**
   * Piętro do
   * @format int32
   * @example 4
   */
  floorTo?: number;
  /**
   * Liczba pięter od
   * @format int32
   * @example 4
   */
  floorsFrom?: number;
  /**
   * Liczba pięter do
   * @format int32
   * @example 4
   */
  floorsTo?: number;
  /**
   * Liczba pokoi od
   * @format int32
   * @example 4
   */
  numberOfRoomsFrom?: number;
  /**
   * Liczba pokoi do
   * @format int32
   * @example 4
   */
  numberOfRoomsTo?: number;
  typeOfMarket?: TypeOfMarketEnum[];
  buildingType?: OtherBuildingTypeEnum[];
}

/** Typ rynku */
export enum TypeOfMarketEnum {
  Pierwotny = "Pierwotny",
  Wtorny = "Wtórny",
}

/** Typ budynku */
export enum HouseBuildingTypeEnum {
  Wolnostojacy = "Wolnostojący",
  Blizniak = "Bliźniak",
  Szeregowy = "Szeregowy",
  Pozostale = "Pozostałe",
}

export interface HousesFilterDto {
  /**
   * Nazwa filtra
   * @example "Nazwa testowa"
   */
  name?: string;
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  module: Module;
  /**
   * Powiadomienia SMS
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia Email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia Push
   * @example true
   */
  pushAlert: boolean;
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Opóźnienie powiadomień
   * @format int32
   */
  notificationsDelay: number;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom?: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount?: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  includeAi: boolean;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  offerFrom?: OfferFromEnum[];
  /**
   * Id lokalizacji
   * @example [{"id":15},{"id":25}]
   */
  locations: LocationDto[];
  /**
   * Id lokalizacji OSM
   * @example [{"id":15},{"id":25}]
   */
  filterLocations?: OsmLocationDto[];
  /**
   * Id filtra
   * @format int64
   */
  id: number;
  /**
   * Liczba pokoi w domu od
   * @format int32
   * @min 0
   * @example 3
   */
  numberOfRoomsFrom?: number;
  /**
   * Liczba pokoi w domu do
   * @format int32
   * @min 0
   * @example 5
   */
  numberOfRoomsTo?: number;
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  typeOfMarket?: TypeOfMarketEnum[];
  buildingType?: HouseBuildingTypeEnum[];
  /**
   * Liczba pieter od
   * Pojedynczy wybór
   * @format int32
   * @example 0
   */
  floorFrom?: null;
  /**
   * Liczba pieter do
   * Pojedynczy wybór
   * @format int32
   * @example 2
   */
  floorTo?: null;
}

/** Stan nieruchomości */
export enum BuildingConditionEnum {
  DoRemontu = "Do remontu",
  Dobry = "Dobry",
  Deweloperski = "Deweloperski",
  PoRemoncie = "Po remoncie",
}

/** Typ budynku */
export enum FlatBuildingTypeEnum {
  Blok = "Blok",
  Apartamentowiec = "Apartamentowiec",
  Kamienica = "Kamienica",
  Pozostale = "Pozostałe",
}

export interface FlatsFilterDto {
  /**
   * Nazwa filtra
   * @example "Nazwa testowa"
   */
  name?: string;
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  module: Module;
  /**
   * Powiadomienia SMS
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia Email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia Push
   * @example true
   */
  pushAlert: boolean;
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Opóźnienie powiadomień
   * @format int32
   */
  notificationsDelay: number;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom?: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount?: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  includeAi: boolean;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  offerFrom?: OfferFromEnum[];
  /**
   * Id lokalizacji
   * @example [{"id":15},{"id":25}]
   */
  locations: LocationDto[];
  /**
   * Id lokalizacji OSM
   * @example [{"id":15},{"id":25}]
   */
  filterLocations?: OsmLocationDto[];
  /**
   * Id filtra
   * @format int64
   */
  id: number;
  /**
   * Liczba pokoi w mieszkaniu od
   * @format int32
   * @min 0
   * @example 1
   */
  numberOfRoomsFrom?: number;
  /**
   * Liczba pokoi w mieszkaniu do
   * @format int32
   * @min 0
   * @example 3
   */
  numberOfRoomsTo?: number;
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  typeOfMarket?: TypeOfMarketEnum[];
  buildingType?: FlatBuildingTypeEnum[];
  buildingCondition?: BuildingConditionEnum[];
  /**
   * Piętro na którym jest mieszkanie od
   * @format int32
   * @example 4
   */
  floorFrom?: number;
  /**
   * Piętro na którym jest mieszkanie do
   * @format int32
   * @example 4
   */
  floorTo?: number;
  /**
   * Piętra w budynku od
   * @format int32
   * @example 4
   */
  floorsFrom?: number;
  /**
   * Piętra w budynku do
   * @format int32
   * @example 4
   */
  floorsTo?: number;
}

/** Informacje o blokadzie */
export type BlockageInfoDto = {
  /**
   * Id oryginalnego ogłoszenia zablokowanego
   * Id oryginalnego ogłoszenia mogą się zmienić podczas działania aplikacji
   * @format int64
   * @example 1
   */
  originalAdvertisementId: number;
  module: Module;
  /**
   * Czas blokady w dniach
   * @format int32
   * @example 14
   */
  days: number;
  /**
   * Data blokady
   * @format date-time
   */
  blockedDate: string;
  /**
   * Nazwa użytkownika blokującego ogłoszenie
   * @example "Jan Kowalski"
   */
  userName: string;
  /**
   * Czy blokada jest stała
   * @example true
   */
  permanentlyBlocked: boolean;
  /**
   * Czy jest ustawiona blokada
   * @example true
   */
  notificationStatus: boolean;
  myBlockage?: boolean;
} | null;

/**
 * Ogólny stan budynku
 * @example "Dobry"
 */
export enum BuildingOverallConditionEnum {
  Zly = "Zły",
  Dobry = "Dobry",
  PoRenowacji = "Po renowacji",
  BardzoDobry = "Bardzo dobry",
  Nowy = "Nowy",
}

/** Moja opinia */
export interface MyOpinion {
  /**
   * Id opinii
   * @format int64
   */
  id: number;
  /**
   * Data dodania
   * @format date-time
   */
  dateAdded: string;
  /**
   * Liczba gwiazdek
   * @format int32
   * @example 1
   */
  numberOfStars: number;
  /**
   * Opis opinii
   * @example "xyz"
   */
  content?: string | null;
}

export interface NoteDto {
  /**
   * Id notatki
   * @format int64
   * @example 1
   */
  noteId: number;
  /**
   * Tekst
   * @example "Przykładowy tekst"
   */
  content: string;
  /**
   * Data dodania notatki
   * @format date-time
   */
  date: string;
  /**
   * Czy notatka pochodzi z oryginalnego ogłoszenia
   * @example true
   */
  originalNote: boolean;
  /**
   * Nazwa użytkownika
   * @example "Jan Kowalski"
   */
  userName?: string;
  /**
   * Czy użytkownik jest właścicielem notatki
   * @example true
   */
  noteOwner: boolean;
}

/** Paginacja */
export interface PageableObject {
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  offset?: number;
  /** Sortowanie */
  sort?: SortObject;
  paged?: boolean;
  unpaged?: boolean;
}

export interface ReactionDto {
  /** Like Status */
  likeStatus?: boolean;
  /** Unlike Status */
  unlikeStatus?: boolean;
  /** Viewed Status */
  viewedStatus?: boolean;
  /** Outdated Status */
  outdatedStatus?: boolean;
  /** Arranged Status */
  arrangedStatus?: boolean;
  /** Phone Status */
  phoneStatus?: boolean;
  /** Hide Status */
  hideStatus?: boolean;
  /** OpenedStatus */
  openedStatus?: boolean;
}

/** Zawartość */
export interface SaleAiPlotDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @example "2000000"
   */
  priceBeforeModification?: string;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Średnia ocena społeczności
   * @format double
   * @example 3
   */
  communityScore: number;
  /**
   * Liczba komentarzy społeczności
   * @format int32
   * @example 2
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii społeczności
   * @format int32
   * @example 1
   */
  numberOfCommunityOpinions: number;
  offerFrom: OfferFromEnum;
  myOpinion?: MyOpinion;
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes?: number | null;
  blockageInfo?: BlockageInfoDto;
  /** Status ogłoszenia */
  status?: SaleStatusDto;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  buildingType?: PlotBuildingTypeEnum;
  typeOfMarket?: TypeOfMarketEnum;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  predictedBuildingType?: PlotBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
}

export interface SaleAiPlotDtoPage {
  /** Zawartość */
  content?: SaleAiPlotDto[];
  /** Paginacja */
  pageable?: PageableObject;
  /** Czy to pierwsza strona */
  first?: boolean;
  /** Czy to ostatnia strona */
  last?: boolean;
  /**
   * Rozmiar strony
   * @format int32
   */
  size?: number;
  /**
   * Numer bieżącej strony
   * @format int32
   */
  number?: number;
  /** Sortowanie */
  sort?: SortObject;
  /**
   * Liczba elementów na bieżącej stronie
   * @format int32
   */
  numberOfElements?: number;
  /**
   * Liczba wszystkich elementów
   * @format int64
   */
  totalElements?: number;
  /**
   * Liczba wszystkich dostępnych elementów w zależności od pakietu
   * @format int64
   */
  availableTotalElements?: number;
  /**
   * Liczba wszystkich stron
   * @format int32
   */
  totalPages?: number;
}

/** Status ogłoszenia */
export interface SaleStatusDto {
  /**
   * Ogłoszenie jest nowo dodane
   * @example true
   */
  isNew: boolean;
  /**
   * Ogłoszenie zostało zmodyfikowane
   * @example true
   */
  isModification: boolean;
  /**
   * Ogłoszenie zostało podbite
   * @example true
   */
  isTossedUp: boolean;
}

/** Sortowanie */
export interface SortObject {
  sorted?: boolean;
  empty?: boolean;
  unsorted?: boolean;
}

/** Strona z ogłoszeniami */
export interface CustomPage {
  /** Zawartość */
  content?: object[];
  /** Paginacja */
  pageable?: PageableObject;
  /** Czy to pierwsza strona */
  first?: boolean;
  /** Czy to ostatnia strona */
  last?: boolean;
  /**
   * Rozmiar strony
   * @format int32
   */
  size?: number;
  /**
   * Numer bieżącej strony
   * @format int32
   */
  number?: number;
  /** Sortowanie */
  sort?: SortObject;
  /**
   * Liczba elementów na bieżącej stronie
   * @format int32
   */
  numberOfElements?: number;
  /**
   * Liczba wszystkich elementów
   * @format int64
   */
  totalElements?: number;
  /**
   * Liczba wszystkich dostępnych elementów w zależności od pakietu
   * @format int64
   */
  availableTotalElements?: number;
  /**
   * Liczba wszystkich stron
   * @format int32
   */
  totalPages?: number;
}

/** Zawartość */
export interface SaleAiOtherDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @example "2000000"
   */
  priceBeforeModification?: string;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Średnia ocena społeczności
   * @format double
   * @example 3
   */
  communityScore: number;
  /**
   * Liczba komentarzy społeczności
   * @format int32
   * @example 2
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii społeczności
   * @format int32
   * @example 1
   */
  numberOfCommunityOpinions: number;
  offerFrom: OfferFromEnum;
  myOpinion?: MyOpinion;
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes?: number | null;
  blockageInfo?: BlockageInfoDto;
  /** Status ogłoszenia */
  status?: SaleStatusDto;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Liczba pięter w budynku
   * @example "10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: OtherBuildingTypeEnum;
  typeOfMarket?: TypeOfMarketEnum;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: OtherBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
}

export interface SaleAiOtherDtoPage {
  /** Zawartość */
  content?: SaleAiOtherDto[];
  /** Paginacja */
  pageable?: PageableObject;
  /** Czy to pierwsza strona */
  first?: boolean;
  /** Czy to ostatnia strona */
  last?: boolean;
  /**
   * Rozmiar strony
   * @format int32
   */
  size?: number;
  /**
   * Numer bieżącej strony
   * @format int32
   */
  number?: number;
  /** Sortowanie */
  sort?: SortObject;
  /**
   * Liczba elementów na bieżącej stronie
   * @format int32
   */
  numberOfElements?: number;
  /**
   * Liczba wszystkich elementów
   * @format int64
   */
  totalElements?: number;
  /**
   * Liczba wszystkich dostępnych elementów w zależności od pakietu
   * @format int64
   */
  availableTotalElements?: number;
  /**
   * Liczba wszystkich stron
   * @format int32
   */
  totalPages?: number;
}

/** Zawartość */
export interface SaleAiHouseDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @example "2000000"
   */
  priceBeforeModification?: string;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Średnia ocena społeczności
   * @format double
   * @example 3
   */
  communityScore: number;
  /**
   * Liczba komentarzy społeczności
   * @format int32
   * @example 2
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii społeczności
   * @format int32
   * @example 1
   */
  numberOfCommunityOpinions: number;
  offerFrom: OfferFromEnum;
  myOpinion?: MyOpinion;
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes?: number | null;
  blockageInfo?: BlockageInfoDto;
  /** Status ogłoszenia */
  status?: SaleStatusDto;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Liczba pięter w budynku
   * @example "10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: HouseBuildingTypeEnum;
  typeOfMarket?: TypeOfMarketEnum;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: HouseBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
}

export interface SaleAiHouseDtoPage {
  /** Zawartość */
  content?: SaleAiHouseDto[];
  /** Paginacja */
  pageable?: PageableObject;
  /** Czy to pierwsza strona */
  first?: boolean;
  /** Czy to ostatnia strona */
  last?: boolean;
  /**
   * Rozmiar strony
   * @format int32
   */
  size?: number;
  /**
   * Numer bieżącej strony
   * @format int32
   */
  number?: number;
  /** Sortowanie */
  sort?: SortObject;
  /**
   * Liczba elementów na bieżącej stronie
   * @format int32
   */
  numberOfElements?: number;
  /**
   * Liczba wszystkich elementów
   * @format int64
   */
  totalElements?: number;
  /**
   * Liczba wszystkich dostępnych elementów w zależności od pakietu
   * @format int64
   */
  availableTotalElements?: number;
  /**
   * Liczba wszystkich stron
   * @format int32
   */
  totalPages?: number;
}

/** Opinia AI */
export interface AiOpinion {
  /**
   * Id opinii
   * @format int64
   */
  id: number;
  /**
   * Data dodania
   * @format date-time
   */
  dateAdded: string;
  /**
   * Liczba gwiazdek
   * @format int32
   * @example 1
   */
  numberOfStars: number;
  /**
   * Opis opinii znaków
   * @example "xyz"
   */
  content?: string | null;
  /**
   * Opis opinii 100 znaków
   * @example "xyz"
   */
  contentMobile?: string | null;
  /**
   * Opis opinii 180 znaków
   * @example "xyz"
   */
  contentWeb?: string | null;
  lengthMoreThanMobile?: boolean;
  lengthMoreThanWeb?: boolean;
}

/** Stan nieruchomości */
export enum BuildingCondition {
  DoRemontu = "Do remontu",
  Dobry = "Dobry",
  Deweloperski = "Deweloperski",
  PoRemoncie = "Po remoncie",
}

export interface Costs {
  notary?: string;
  broker?: string;
  maintenanceFees?: string;
  rentFees?: string;
  saleBroker?: string;
  tax?: string;
  renovationFrom1To30Amount?: string;
  renovationFrom30To40Amount?: string;
  renovationFrom40To50Amount?: string;
  renovationFrom50To60Amount?: string;
  renovationFrom60PlusAmount?: string;
  portalFees?: string;
  photographerAmount?: string;
  userOption?: string;
  pcc?: string;
  sumOfCosts?: string;
}

export interface FlipResultDTO {
  isIndividualFlip?: boolean;
  maxPurchasePrice?: string;
  margin?: string;
  profit?: string;
  realPrice?: string;
  certainPrice?: string;
  costs?: Costs;
}

/** Zawartość */
export interface SaleAiFlatDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @example "2000000"
   */
  priceBeforeModification?: string;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Średnia ocena społeczności
   * @format double
   * @example 3
   */
  communityScore: number;
  /**
   * Liczba komentarzy społeczności
   * @format int32
   * @example 2
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii społeczności
   * @format int32
   * @example 1
   */
  numberOfCommunityOpinions: number;
  offerFrom: OfferFromEnum;
  myOpinion?: MyOpinion;
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes?: number | null;
  blockageInfo?: BlockageInfoDto;
  /** Status ogłoszenia */
  status?: SaleStatusDto;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: FlatBuildingTypeEnum;
  typeOfMarket?: TypeOfMarketEnum;
  buildingCondition?: BuildingCondition;
  flipResult?: FlipResultDTO;
  /**
   * Przewidywana cena po remoncie
   * Cena przewidziana przez model własny model AI po remoncie
   * @example "300000"
   */
  predictedPriceAfterRenovation?: string;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: FlatBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
  aiOpinion?: AiOpinion;
}

export interface SaleAiFlatDtoPage {
  /** Zawartość */
  content?: SaleAiFlatDto[];
  /** Paginacja */
  pageable?: PageableObject;
  /** Czy to pierwsza strona */
  first?: boolean;
  /** Czy to ostatnia strona */
  last?: boolean;
  /**
   * Rozmiar strony
   * @format int32
   */
  size?: number;
  /**
   * Numer bieżącej strony
   * @format int32
   */
  number?: number;
  /** Sortowanie */
  sort?: SortObject;
  /**
   * Liczba elementów na bieżącej stronie
   * @format int32
   */
  numberOfElements?: number;
  /**
   * Liczba wszystkich elementów
   * @format int64
   */
  totalElements?: number;
  /**
   * Liczba wszystkich dostępnych elementów w zależności od pakietu
   * @format int64
   */
  availableTotalElements?: number;
  /**
   * Liczba wszystkich stron
   * @format int32
   */
  totalPages?: number;
}

export interface MetaValueDto {
  /** Klucz */
  key: string;
  /** Wartość */
  value?: string;
  /** Ai Wartość */
  aiValue?: string;
}

export interface ModificationDateDto {
  /**
   * Data modyfikacji
   * @format date-time
   */
  date: string;
  modificationDetail?: ModificationDto[];
}

export interface ModificationDto {
  /** Zmodyfikowane pole */
  field: string;
  /** Nowa wartość modyfikacji */
  newValue?: string;
  /** Stara wartość modyfikacji */
  oldValue?: string;
}

export interface RaisesValueDto {
  /** @format date-time */
  date?: string;
}

export interface SaleAiFlatHashDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @example "2000000"
   */
  priceBeforeModification?: string;
  /**
   * Cena
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes?: number;
  /**
   * Średnia ocena społeczności
   * @format double
   * @example 3
   */
  communityScore: number;
  /**
   * Liczba komentarzy społeczności
   * @format int32
   * @example 2
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii społeczności
   * @format int32
   * @example 1
   */
  numberOfCommunityOpinions: number;
  myOpinion?: MyOpinion;
  blockageInfo?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** Status ogłoszenia */
  status?: SaleStatusDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: FlatBuildingTypeEnum;
  offerFrom?: OfferFromEnum;
  typeOfMarket?: TypeOfMarketEnum;
  buildingCondition?: BuildingCondition;
  flipResult?: FlipResultDTO;
  /**
   * Przewidywana cena po remoncie
   * Cena przewidziana przez model własny model AI po remoncie
   * @example "300000"
   */
  predictedPriceAfterRenovation?: string;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: FlatBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
}

export interface SaleAiPlotHashDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @example "2000000"
   */
  priceBeforeModification?: string;
  /**
   * Cena
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes?: number;
  /**
   * Średnia ocena społeczności
   * @format double
   * @example 3
   */
  communityScore: number;
  /**
   * Liczba komentarzy społeczności
   * @format int32
   * @example 2
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii społeczności
   * @format int32
   * @example 1
   */
  numberOfCommunityOpinions: number;
  myOpinion?: MyOpinion;
  blockageInfo?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** Status ogłoszenia */
  status?: SaleStatusDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  buildingType?: PlotBuildingTypeEnum;
  offerFrom?: OfferFromEnum;
  typeOfMarket?: TypeOfMarketEnum;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: PlotBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
}

export interface SaleAiOtherHashDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @example "2000000"
   */
  priceBeforeModification?: string;
  /**
   * Cena
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes?: number;
  /**
   * Średnia ocena społeczności
   * @format double
   * @example 3
   */
  communityScore: number;
  /**
   * Liczba komentarzy społeczności
   * @format int32
   * @example 2
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii społeczności
   * @format int32
   * @example 1
   */
  numberOfCommunityOpinions: number;
  myOpinion?: MyOpinion;
  blockageInfo?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** Status ogłoszenia */
  status?: SaleStatusDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: OtherBuildingTypeEnum;
  offerFrom?: OfferFromEnum;
  typeOfMarket?: TypeOfMarketEnum;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: OtherBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
}

export interface SaleAiHouseHashDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @example "2000000"
   */
  priceBeforeModification?: string;
  /**
   * Cena
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  /**
   * Liczba wszystkich notatek
   * @format int32
   * @example 1
   */
  numberOfNotes?: number;
  /**
   * Średnia ocena społeczności
   * @format double
   * @example 3
   */
  communityScore: number;
  /**
   * Liczba komentarzy społeczności
   * @format int32
   * @example 2
   */
  numberOfCommunityComments: number;
  /**
   * Liczba opinii społeczności
   * @format int32
   * @example 1
   */
  numberOfCommunityOpinions: number;
  myOpinion?: MyOpinion;
  blockageInfo?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** Status ogłoszenia */
  status?: SaleStatusDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: HouseBuildingTypeEnum;
  offerFrom?: OfferFromEnum;
  typeOfMarket?: TypeOfMarketEnum;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: HouseBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
}

export interface SaleOpinionResult {
  /** Lista opinii ogłoszenia */
  opinions?: SingleSaleOpinion[];
  /**
   * Ocena społeczności
   * @format double
   * @example 4.2
   */
  communityScore: number;
  /**
   * Precyzja oceny przez aplikację
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Ocena aplikacji
   * @format double
   * @example 2.5
   */
  score: number;
}

/** Lista opinii ogłoszenia */
export interface SingleSaleOpinion {
  /**
   * Id opinii
   * @format int64
   * @example 1
   */
  opinionId: number;
  /**
   * Data dodania opini
   * @format date-time
   */
  dateAdded: string;
  /**
   * Opis opinii
   * @example "xyz"
   */
  content?: string | null;
  /**
   * Liczba gwiazdek
   * @format int32
   * @example 2
   */
  numberOfStars: number;
  /**
   * Status opinii
   * Wartość true kiedy ta opinia należy do aktualnie zalogowanego użytkownika
   * @example true
   */
  loggedUserOpinion: boolean;
}

export interface SavedFiltersDto {
  /**
   * Id filtra
   * @format int64
   * @example 1
   */
  id?: number;
  /**
   * Nazwa filtra
   * @example "Nazwa testowa"
   */
  name?: string;
  module?: Module;
  /**
   * Powiadomienia SMS
   * @example true
   */
  alertSms?: boolean;
  /**
   * Powiadomienia Email
   * @example true
   */
  alertEmail?: boolean;
  /**
   * Powiadomienia Push
   * @example true
   */
  pushAlert?: boolean;
}

export interface DuplicatePlotAiDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * EncryptedId
   * @example "Fafeqrvsdad"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena za metr kwadratowy
   * @format double
   * @example 4000
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "143546334"
   */
  phoneNumber?: string;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications?: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises?: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  buildingType?: PlotBuildingTypeEnum;
  offerFrom?: OfferFromEnum;
  typeOfMarket?: TypeOfMarketEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  predictedBuildingType?: PlotBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
}

export interface DuplicateOtherAiDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * EncryptedId
   * @example "Fafeqrvsdad"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena za metr kwadratowy
   * @format double
   * @example 4000
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "143546334"
   */
  phoneNumber?: string;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications?: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises?: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: OtherBuildingTypeEnum;
  offerFrom?: OfferFromEnum;
  typeOfMarket?: TypeOfMarketEnum;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: OtherBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
}

export interface DuplicateHouseAiDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * EncryptedId
   * @example "Fafeqrvsdad"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena za metr kwadratowy
   * @format double
   * @example 4000
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "143546334"
   */
  phoneNumber?: string;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications?: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises?: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: HouseBuildingTypeEnum;
  offerFrom?: OfferFromEnum;
  typeOfMarket?: TypeOfMarketEnum;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: HouseBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
}

export interface DuplicateFlatAiDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * EncryptedId
   * @example "Fafeqrvsdad"
   */
  encryptedId: string;
  /** Zdjęcia */
  photos?: string[];
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  lastUpdated?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @format double
   * @example 2000000
   */
  priceBeforeModification?: number;
  /**
   * Cena nieruchomości
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * Cena za metr kwadratowy
   * @format double
   * @example 4000
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "143546334"
   */
  phoneNumber?: string;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications?: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises?: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  reaction?: ReactionDto;
  note?: NoteDto;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: FlatBuildingTypeEnum;
  offerFrom?: OfferFromEnum;
  typeOfMarket?: TypeOfMarketEnum;
  buildingCondition?: BuildingCondition;
  /**
   * Przewidywana cena po remoncie
   * Cena przewidziana przez model własny model AI po remoncie
   * @example "300000"
   */
  predictedPriceAfterRenovation?: string;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: FlatBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
  flipResult?: FlipResultDTO;
}

export interface SaleAiPlotDetailDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcie główne */
  photo?: string;
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  modificationDate?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @example "2000000"
   */
  priceBeforeModification?: string;
  /**
   * Cena
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  offerFrom: OfferFromEnum;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  blockageInfoDto?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** Status ogłoszenia */
  status?: SaleStatusDto;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  buildingType?: PlotBuildingTypeEnum;
  typeOfMarket?: TypeOfMarketEnum;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  predictedBuildingType?: PlotBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
}

export interface SaleAiOtherDetailDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcie główne */
  photo?: string;
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  modificationDate?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @example "2000000"
   */
  priceBeforeModification?: string;
  /**
   * Cena
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  offerFrom: OfferFromEnum;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  blockageInfoDto?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** Status ogłoszenia */
  status?: SaleStatusDto;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Liczba pięter w budynku
   * @example "10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: OtherBuildingTypeEnum;
  typeOfMarket?: TypeOfMarketEnum;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: OtherBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
}

export interface SaleAiHouseDetailDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcie główne */
  photo?: string;
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  modificationDate?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @example "2000000"
   */
  priceBeforeModification?: string;
  /**
   * Cena
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  offerFrom: OfferFromEnum;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  blockageInfoDto?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** Status ogłoszenia */
  status?: SaleStatusDto;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Liczba pięter w budynku
   * @example "10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: HouseBuildingTypeEnum;
  typeOfMarket?: TypeOfMarketEnum;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: HouseBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
}

export interface SaleAiFlatDetailDto {
  /**
   * Id ogłoszenia
   * @format int64
   */
  advertisementId: number;
  /**
   * Id zaszyfrowane
   * @example "wdavd==24cd"
   */
  encryptedId: string;
  /** Zdjęcie główne */
  photo?: string;
  /** Lokalizacja */
  location: string;
  /**
   * Data dodania
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  dateAdded: string;
  /**
   * Data modyfikacji
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  modificationDate?: string;
  /**
   * Tytuł
   * @example "Mieszkanie"
   */
  title: string;
  /**
   * Opis
   * @example "Mieszkanie"
   */
  description: string;
  module: Module;
  /**
   * Ocena nieruchomości
   * @format double
   * @example 5
   */
  score: number;
  /**
   * Precyzja oceny
   * Od 0 do 6
   * @format int32
   * @example 2
   */
  scorePrecision: number;
  /**
   * Cena nieruchomości przed modyfikacją
   * @example "2000000"
   */
  priceBeforeModification?: string;
  /**
   * Cena
   * @format double
   * @example 100000
   */
  price?: number;
  /**
   * PricePerSquareMeter
   * @format double
   * @example 50
   */
  pricePerSquareMeter?: number;
  /**
   * Powierzchnia
   * @format double
   * @example 100
   */
  area?: number;
  /**
   * Numer telefonu
   * @example "1435463364"
   */
  phoneNumber?: string;
  /**
   * Liczba duplikatów
   * @format int32
   * @example 3
   */
  numberOfDuplicates: number;
  /**
   * Liczba modyfikacji
   * @format int32
   * @example 3
   */
  numberOfModifications: number;
  /**
   * Liczba podbić
   * @format int32
   * @example 3
   */
  numberOfRaises: number;
  /**
   * Portal
   * @example "Morizon"
   */
  portal: string;
  /** Link */
  link: string;
  /**
   * W duplikatach znajduje się niższa cena
   * @example true
   */
  duplicateWithLowestPrice: boolean;
  /**
   * W duplikatach znajduje się oferta prywatna
   * @example true
   */
  duplicateWithPrivateOffer: boolean;
  offerFrom: OfferFromEnum;
  reaction?: ReactionDto;
  note?: NoteDto[];
  modifications?: ModificationDateDto[];
  metaValue?: MetaValueDto[];
  blockageInfoDto?: BlockageInfoDto;
  raisesValue?: RaisesValueDto[];
  /** Status ogłoszenia */
  status?: SaleStatusDto;
  /**
   * Data dodania najstarszego duplikatu
   * Czas w formacie LocalDateTime
   * @format date-time
   */
  oldestDuplicateDateAdded: string;
  /** EncryptedId oryginalngo ogłoszenia */
  originalEncryptedId: string;
  /**
   * Ogłoszenie wygasłe
   * @example false
   */
  archived: boolean;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro/Liczba pięter w budynku
   * @example "2/10"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2000
   */
  builtYear?: number;
  buildingType?: FlatBuildingTypeEnum;
  typeOfMarket?: TypeOfMarketEnum;
  buildingCondition?: BuildingCondition;
  flipResult?: FlipResultDTO;
  /**
   * Przewidywana cena po remoncie
   * Cena przewidziana przez model własny model AI po remoncie
   * @example "300000"
   */
  predictedPriceAfterRenovation?: string;
  predictedBuildingOverallCondition?: BuildingOverallConditionEnum;
  /** Lokalizacja */
  predictedLocation?: string;
  /** Cena nieruchomości */
  predictedPrice?: string;
  /** PricePerSquareMeter */
  predictedPricePerSquareMeter?: string;
  /** Powierzchnia */
  predictedArea?: string;
  /** Numer telefonu */
  predictedPhoneNumber?: string;
  predictedOfferFrom?: OfferFromEnum;
  /** Liczba pokoi */
  predictedNumberOfRooms?: string;
  /** Piętro/Liczba pięter w budynku */
  predictedFloor?: string;
  /** Rok budowy */
  predictedBuiltYear?: string;
  predictedBuildingType?: FlatBuildingTypeEnum;
  predictedTypeOfMarket?: TypeOfMarketEnum;
  predictedBuildingCondition?: BuildingConditionEnum;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://192.168.31.12:8080";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://192.168.31.12:8080
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  v2 = {
    /**
     * No description
     *
     * @tags Tworzenie opinii
     * @name Update
     * @summary Aktualizacja opinii użytkownika
     * @request PUT:/v2/sale-offer/opinion/update
     * @secure
     */
    update: (
      query: {
        /** Moduł, typ nieruchomości */
        module: Module;
      },
      data: string,
      params: RequestParams = {},
    ) =>
      this.http.request<OpinionUpdateInformation, object | string>({
        path: `/v2/sale-offer/opinion/update`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name PlotsFilterDetail
     * @summary Edycja filtra działki
     * @request PUT:/v2/sale-offer/filter/edit/plot
     * @secure
     */
    plotsFilterDetail: (data: PlotsFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/filter/edit/plot`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name OtherFilterDetail
     * @summary Edycja filtra pozostałych typów ogłoszeń
     * @request PUT:/v2/sale-offer/filter/edit/other
     * @secure
     */
    otherFilterDetail: (data: OtherFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/filter/edit/other`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name HousesFilterDetail
     * @summary Edycja filtra domu
     * @request PUT:/v2/sale-offer/filter/edit/house
     * @secure
     */
    housesFilterDetail: (data: HousesFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/filter/edit/house`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name FlatsFilterDetail
     * @summary Edycja filtra mieszkania
     * @request PUT:/v2/sale-offer/filter/edit/flat
     * @secure
     */
    flatsFilterDetail: (data: FlatsFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/filter/edit/flat`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie opinii
     * @name Create
     * @summary Tworzenie nowej opinii
     * @request POST:/v2/sale-offer/opinion/create
     * @secure
     */
    create: (
      query: {
        /** Moduł, typ nieruchomości */
        module: Module;
      },
      data: string,
      params: RequestParams = {},
    ) =>
      this.http.request<OpinionUpdateInformation, object | string>({
        path: `/v2/sale-offer/opinion/create`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name CreateNewFilter
     * @summary Dodanie filtra działki
     * @request POST:/v2/sale-offer/filter/add/plot
     * @secure
     */
    createNewFilter: (data: PlotsFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/filter/add/plot`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name CreateNewFilter1
     * @summary Dodanie filtra pozostałych typów ogłoszenia
     * @request POST:/v2/sale-offer/filter/add/other
     * @secure
     */
    createNewFilter1: (data: OtherFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/filter/add/other`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name CreateNewFilter2
     * @summary Dodanie filtra domu
     * @request POST:/v2/sale-offer/filter/add/house
     * @secure
     */
    createNewFilter2: (data: HousesFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/filter/add/house`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name CreateNewFilter3
     * @summary Dodanie filtra mieszkania
     * @request POST:/v2/sale-offer/filter/add/flat
     * @secure
     */
    createNewFilter3: (data: FlatsFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/filter/add/flat`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie plików Excel
     * @name DownloadPlotsExcel
     * @summary Pobieranie pliku Excel z ogłoszeniami działek
     * @request POST:/v2/sale-offer/excel/plot
     * @secure
     */
    downloadPlotsExcel: (data: PlotsFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/excel/plot`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie plików Excel
     * @name DownloadOtherExcel
     * @summary Pobieranie pliku Excel z ogłoszeniami pozostałych typów nieruchomości
     * @request POST:/v2/sale-offer/excel/other
     * @secure
     */
    downloadOtherExcel: (data: OtherFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/excel/other`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie plików Excel
     * @name DownloadHousesExcel
     * @summary Pobieranie pliku Excel z ogłoszeniami domów
     * @request POST:/v2/sale-offer/excel/house
     * @secure
     */
    downloadHousesExcel: (data: HousesFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/excel/house`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie plików Excel
     * @name DownloadFlatsExcel
     * @summary Pobieranie pliku Excel z ogłoszeniami mieszkań
     * @request POST:/v2/sale-offer/excel/flat
     * @secure
     */
    downloadFlatsExcel: (data: FlatsFilterDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/excel/flat`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name DownloadAiPlotAdvertisements
     * @summary Pobieranie ogłoszeń działek
     * @request POST:/v2/sale-offer/advertisement/ai/plot
     * @secure
     */
    downloadAiPlotAdvertisements: (
      query: {
        /** @format int32 */
        size: number;
        /** @format int32 */
        page: number;
      },
      data: PlotsFilterDto,
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiPlotDtoPage, object>({
        path: `/v2/sale-offer/advertisement/ai/plot`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name DownloadAiPlotAdvertisements1
     * @summary Pobieranie pozostałych ogłoszeń
     * @request POST:/v2/sale-offer/advertisement/ai/other
     * @secure
     */
    downloadAiPlotAdvertisements1: (
      query: {
        /** @format int32 */
        size: number;
        /** @format int32 */
        page: number;
      },
      data: OtherFilterDto,
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiOtherDtoPage, object>({
        path: `/v2/sale-offer/advertisement/ai/other`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name DownloadAiHouseAdvertisements
     * @summary Pobieranie ogłoszeń domów
     * @request POST:/v2/sale-offer/advertisement/ai/house
     * @secure
     */
    downloadAiHouseAdvertisements: (
      query: {
        /** @format int32 */
        size: number;
        /** @format int32 */
        page: number;
      },
      data: HousesFilterDto,
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiHouseDtoPage, object>({
        path: `/v2/sale-offer/advertisement/ai/house`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name DownloadAiFlatAdvertisements
     * @summary Pobieranie ogłoszeń mieszkań
     * @request POST:/v2/sale-offer/advertisement/ai/flat
     * @secure
     */
    downloadAiFlatAdvertisements: (
      query: {
        /** @format int32 */
        size: number;
        /** @format int32 */
        page: number;
      },
      data: FlatsFilterDto,
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiFlatDtoPage, object>({
        path: `/v2/sale-offer/advertisement/ai/flat`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie szczegółów ogłoszeń - hash
     * @name FullAiHashAdvertisement
     * @summary Ogłoszenie mieszkań wraz z wszystkimi danymi wyszukiwane po hash
     * @request GET:/v2/sale-offer/single-advertisement/ai/detail
     * @secure
     */
    fullAiHashAdvertisement: (
      query: {
        hash: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiFlatHashDto, object>({
        path: `/v2/sale-offer/single-advertisement/ai/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie szczegółów ogłoszeń - hash
     * @name FullAiHashPlotAdvertisement
     * @summary Ogłoszenie działek wraz z wszystkimi danymi wyszukiwane po hash
     * @request GET:/v2/sale-offer/single-advertisement/ai/detail/plot
     * @secure
     */
    fullAiHashPlotAdvertisement: (
      query: {
        hash: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiPlotHashDto, object>({
        path: `/v2/sale-offer/single-advertisement/ai/detail/plot`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie szczegółów ogłoszeń - hash
     * @name FullAiHashOtherAdvertisement
     * @summary Ogłoszenie pozostałych wraz z wszystkimi danymi wyszukiwane po hash
     * @request GET:/v2/sale-offer/single-advertisement/ai/detail/other
     * @secure
     */
    fullAiHashOtherAdvertisement: (
      query: {
        hash: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiOtherHashDto, object>({
        path: `/v2/sale-offer/single-advertisement/ai/detail/other`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie szczegółów ogłoszeń - hash
     * @name FullAiHashHouseAdvertisement
     * @summary Ogłoszenie domów wraz z wszystkimi danymi wyszukiwane po hash
     * @request GET:/v2/sale-offer/single-advertisement/ai/detail/house
     * @secure
     */
    fullAiHashHouseAdvertisement: (
      query: {
        hash: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiHouseHashDto, object>({
        path: `/v2/sale-offer/single-advertisement/ai/detail/house`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie szczegółów ogłoszeń - hash
     * @name FullAiHashFlatAdvertisement
     * @summary Ogłoszenie mieszkań wraz z wszystkimi danymi wyszukiwane po hash
     * @request GET:/v2/sale-offer/single-advertisement/ai/detail/flat
     * @secure
     */
    fullAiHashFlatAdvertisement: (
      query: {
        hash: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiFlatHashDto, object>({
        path: `/v2/sale-offer/single-advertisement/ai/detail/flat`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie opinii
     * @name FindAllByRent
     * @summary Wyszukiwanie opinii ogłoszenia
     * @request GET:/v2/sale-offer/opinion/find
     * @secure
     */
    findAllByRent: (
      query: {
        /** Moduł, typ nieruchomości */
        module: Module;
        /**
         * Id ogłoszenia
         * @format int64
         */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SaleOpinionResult, string>({
        path: `/v2/sale-offer/opinion/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami podobnych nieruchomości
     * @name GenerateSimilarFilter
     * @summary Generowanie filtru dla podobnych nieruchomości na podstawie ID ogłoszenia
     * @request GET:/v2/sale-offer/filter/similar/generate
     * @secure
     */
    generateSimilarFilter: (
      query: {
        /** @format int64 */
        advertisementId: number;
        module: Module;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/filter/similar/generate`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name FindUserFilters
     * @summary Lista wszystkich filtrów użytkownika
     * @request GET:/v2/sale-offer/filter/list
     * @secure
     */
    findUserFilters: (
      query?: {
        module?: Module;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SavedFiltersDto[], object>({
        path: `/v2/sale-offer/filter/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name PlotsFilterDetail1
     * @summary Szczegóły filtra działki
     * @request GET:/v2/sale-offer/filter/detail/plot
     * @secure
     */
    plotsFilterDetail1: (
      query: {
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PlotsFilterDto, object>({
        path: `/v2/sale-offer/filter/detail/plot`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name OtherFilterDetail1
     * @summary Szczegóły filtra pozostałych
     * @request GET:/v2/sale-offer/filter/detail/other
     * @secure
     */
    otherFilterDetail1: (
      query: {
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<OtherFilterDto, object>({
        path: `/v2/sale-offer/filter/detail/other`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name HouseFilterDetail
     * @summary Szczegóły filtra domu
     * @request GET:/v2/sale-offer/filter/detail/house
     * @secure
     */
    houseFilterDetail: (
      query: {
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<HousesFilterDto, object>({
        path: `/v2/sale-offer/filter/detail/house`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Zarządzanie filtrami
     * @name FlatsFilterDetail1
     * @summary Szczegóły filtra mieszkań
     * @request GET:/v2/sale-offer/filter/detail/flat
     * @secure
     */
    flatsFilterDetail1: (
      query: {
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<FlatsFilterDto, object>({
        path: `/v2/sale-offer/filter/detail/flat`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie duplikatów ogłoszeń
     * @name FindPlotsAiDuplicate
     * @summary Wszystkie duplikaty działek
     * @request GET:/v2/sale-offer/duplicate/find/ai/plot
     * @secure
     */
    findPlotsAiDuplicate: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DuplicatePlotAiDto, object>({
        path: `/v2/sale-offer/duplicate/find/ai/plot`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie duplikatów ogłoszeń
     * @name FindOthersAiDuplicate
     * @summary Wszystkie duplikaty pozostałych
     * @request GET:/v2/sale-offer/duplicate/find/ai/other
     * @secure
     */
    findOthersAiDuplicate: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DuplicateOtherAiDto, object>({
        path: `/v2/sale-offer/duplicate/find/ai/other`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie duplikatów ogłoszeń
     * @name FindHousesAiDuplicate
     * @summary Wszystkie duplikaty domów
     * @request GET:/v2/sale-offer/duplicate/find/ai/house
     * @secure
     */
    findHousesAiDuplicate: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DuplicateHouseAiDto, object>({
        path: `/v2/sale-offer/duplicate/find/ai/house`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie duplikatów ogłoszeń
     * @name FindFlatsAiDuplicate
     * @summary Wszystkie duplikaty mieszkań
     * @request GET:/v2/sale-offer/duplicate/find/ai/flat
     * @secure
     */
    findFlatsAiDuplicate: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DuplicateFlatAiDto, object>({
        path: `/v2/sale-offer/duplicate/find/ai/flat`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name FullAiPlotAdvertisement
     * @summary Ogłoszenie działki wraz z wszystkimi danymi
     * @request GET:/v2/sale-offer/advertisement/ai/detail/plot
     * @secure
     */
    fullAiPlotAdvertisement: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiPlotDetailDto, object>({
        path: `/v2/sale-offer/advertisement/ai/detail/plot`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name FullAiOtherAdvertisement
     * @summary Ogłoszenie pozostałych wraz z wszystkimi danymi
     * @request GET:/v2/sale-offer/advertisement/ai/detail/other
     * @secure
     */
    fullAiOtherAdvertisement: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiOtherDetailDto, object>({
        path: `/v2/sale-offer/advertisement/ai/detail/other`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name FullAiHouseAdvertisement
     * @summary Ogłoszenie domów wraz z wszystkimi danymi
     * @request GET:/v2/sale-offer/advertisement/ai/detail/house
     * @secure
     */
    fullAiHouseAdvertisement: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiHouseDetailDto, object>({
        path: `/v2/sale-offer/advertisement/ai/detail/house`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Wyszukiwanie ogłoszeń i ich szczegółów
     * @name FullAiFlatAdvertisement
     * @summary Ogłoszenie mieszkań wraz z wszystkimi danymi
     * @request GET:/v2/sale-offer/advertisement/ai/detail/flat
     * @secure
     */
    fullAiFlatAdvertisement: (
      query: {
        /** @format int64 */
        advertisementId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SaleAiFlatDetailDto, object>({
        path: `/v2/sale-offer/advertisement/ai/detail/flat`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tworzenie opinii
     * @name Delete
     * @summary Usuwanie opinii użytkownika
     * @request DELETE:/v2/sale-offer/opinion/delete
     * @secure
     */
    delete: (
      query: {
        module: Module;
        /** @format int64 */
        opinionId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<OpinionUpdateInformation, object | string>({
        path: `/v2/sale-offer/opinion/delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description ID - filter id
     *
     * @tags Zarządzanie filtrami
     * @name DeleteFilter
     * @summary Usuwanie filtra
     * @request DELETE:/v2/sale-offer/filter/delete
     * @secure
     */
    deleteFilter: (
      query: {
        module: Module;
        /** @format int64 */
        id: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/v2/sale-offer/filter/delete`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
  };
}
